import axios from "axios";

let axiosInstance = axios.create({
    // baseURL: 'http://localhost:8000',
    baseURL: 'https://admin-dashboard-backend-sbu4.onrender.com/',
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${JSON.parse(token)}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Any 401 from the backend means the JWT is missing/expired — clear the
// stale session and bounce straight to the login page instead of leaving
// the user stuck on a broken screen.
axiosInstance.interceptors.response.use((response) => response, (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== '/login') {
        localStorage.clear();
        window.location.href = '/login';
    }
    return Promise.reject(error);
});

export class ApiService {
    static getInstance() {
        return axiosInstance;
    }
}

export type TokenType = string | null | undefined;
